import React from 'react'
import Subheader from '../../../component/Subheader'
import OtherRoom from '../../RoomDetail/OtherRoom';
import RoomBanner from '../../RoomDetail/RoomBanner';
import RoomQuote from '../../RoomDetail/RoomQuote';
import RoomCount from '../../RoomDetail/RoomCount';
import RoomGallery from '../../RoomDetail/RoomGallery';
import RoomEquipment from '../../RoomDetail/RoomEquipment';
import RoomBook from '../../RoomDetail/RoomBook';

export default function CorbettClub() {
    const heading = "Club Cottages";

    const subheadData = {
        heading: (
                    <>
                    <span className="sr-only">Corbett Room</span> {heading}
                    </>
                ),
        breadcrumb: [
        {
            slug: "/resort-de-coracao-corbett/room-listing",
            name: (
                    <>
                    <span className="sr-only">{heading}</span> Rooms
                    </>
                ),
        },
        {
            slug: "",
            name: "Club Cottages",
        },
        ]
    }

    const roomBanner = {
        image: "/image/corbettclub-cottages-room-detail.webp",
    };

    const roomQuote = {
        content: "There is nothing quite like coming back from a dusty morning safari and sinking into your own private Jacuzzi. These cottages are all about personal indulgence in the middle of nature. With warm wooden finishes and a massive king bed, it feels like a high-end cabin where you can truly hide away from the world, unwind, and enjoy comfortable stays while soaking up the day’s adventures.",
    };

    const roomCount = {
        bedroom: "1",
        bedsize: "1",
        area: "42",
        bathroom: "1",
        guest: "4",
        balcony: "1"
    };

    const roomGallery = [
        { image: "/image/corbett-club-room-gallery-1.webp"},
        { image: "/image/corbett-club-room-gallery-2.webp"},
        { image: "/image/corbett-club-room-gallery-3.webp"},
        { image: "/image/corbett-club-room-gallery-4.webp"},
        { image: "/image/corbett-club-room-gallery-5.webp"},
    ];

    const roomEquipment = {
        description: "Settle into a welcoming space designed to combine everyday comfort with contemporary amenities for a pleasant and relaxing stay.",
        equipment: [
        [
            "Private In-Room Jacuzzi for ultimate relaxation",
            "Pocketed Spring Mattress for a deep sleep",
            "42-inch LED TV with DTH for quiet evenings",
            "Coffee & Tea station replenished daily",
        ],
        [
            "Mini-Refrigerator to keep your drinks cold",
            "Writing Desk and Electrical Outlets for your gear",
            "In-Room Electronic Safe for peace of mind",
            "High-speed Wi-Fi to share your wildlife captures",
        ],
        [
            "Hydropneumatic pressure showers",
            "100% Cotton Linens and soft duvets",
            "Makeup Mirror and Hair Dryer on request",
            "24-Hour Room Service access",
        ]
    ]
    };

    const roomBook = {
        location: "Corbett",
        title: "Club Cottages",
        desc: "Escape into the comfort of Club Cottages at De Coracao Corbett, where rustic charm meets modern indulgence. With a private Jacuzzi, spacious interiors, plush bedding, and thoughtful amenities, these cottages offer a relaxing retreat after an exciting day in the wild.",
        details: [
            "1 King Size Bed + 1 Extra Mattress ",
            "Up to 4 Guests",
            "42 sq.mt"
        ],
        enquireLink: "/contact-us",
        bookLink: "https://www.swiftbook.io/inst/#home?propertyId=701Mn5Ca4GiFpRG7wK2385ZRnQ8BcTaRjrMkE4mjc5NQ==&JDRN=Y"
    };


    const otherRoom = {
        slides: [
            {
                title: 'Premium Cottages',
                bg: '/image/corbett-other-room-2.webp',
                slug: '/resort-de-coracao-corbett/premium-cottages',
                details: [
                "1 King Size Bed + 1 Extra Mattress Allowed",
                "Up to 3 Guests",
                "41 sq.mt",
                ],
            },

            {
                title: 'Luxury Cottages',
                bg: '/image/corbett-other-room-3.webp',
                slug: '/resort-de-coracao-corbett/luxury-cottages',
                details: [
                "1 King Size Bed + 1 Extra Mattress Allowed",
                "Up to 3 Guests",
                "41 sq.mt",
                ],
            },

            {
                title: 'Luxury Room',
                bg: '/image/corbett-other-room-4.webp',
                slug: '/resort-de-coracao-corbett/luxury-room',
                details: [
                "1 King Size Bed + 1 Extra Mattress Allowed",
                "Up to 3 Guests",
                "37 sq.mt",
                ],
            },

            {
                title: 'Family Cottages',
                bg: '/image/corbett-other-room-5.webp',
                slug: '/resort-de-coracao-corbett/family-cottages',
                details: [
                "2 King Size Beds + 1 Extra Mattress Allowed",
                "Up to 6 Guests",
                "67 sq.mt",
                ],
            },
        ],

        allRoom: { link: "/resort-de-coracao-corbett/room-listing"}
    }

  return (
    <>  
        <Subheader subheadData={subheadData} />
        <RoomBanner roomBanner={roomBanner}/>
        <RoomQuote roomQuote={roomQuote}/>
        <RoomCount roomCount={roomCount}/>
        <RoomGallery roomGallery={roomGallery}/>
        <RoomEquipment roomEquipment={roomEquipment}/>
        <RoomBook roomBook={roomBook}/>
        <OtherRoom otherRoom={otherRoom} roomTitle={`${roomBook.location} ${subheadData.heading}`}/>
    </>
  )
}
